import type { TTableHeaders } from '~/misc/v-table/types';

const TABLE_HEADERS: TTableHeaders = ['Type', 'Is market appraisal?'];

export { TABLE_HEADERS };
